import script from "./Users.vue?vue&type=script&lang=ts&setup=true"
export * from "./Users.vue?vue&type=script&lang=ts&setup=true"

import "./Users.vue?vue&type=style&index=0&id=c0107086&lang=scss&scoped=true"
script.__scopeId = "data-v-c0107086"

export default script